import * as React from 'react';

import { StyledButtonAddPage } from './styles';
import CombinePanel from '../../../containers/Editor/CombinePanel';
import Utils from '../../../utils';

const ButtonAddPage = () => {
	const [isCombinePanelDisplayed, setIsCombinePanelDisplayed] = React.useState(false);

	return (
		<>
			<StyledButtonAddPage
				type="button"
				onClick={() => setIsCombinePanelDisplayed(true)}
			>
				{Utils.getSvgIcon('iconset_plus')}
			</StyledButtonAddPage>
			<CombinePanel
				importManagerId="combine"
				isDisplayed={isCombinePanelDisplayed}
				onCancel={() => setIsCombinePanelDisplayed(false)}
			/>
		</>
	);
};

export default ButtonAddPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonAddPage/index.tsx